import type { SxProps, Theme } from "@mui/material/styles";

import { customGradients } from "@/theme/customTokens";

export const ring =
  (size: number): SxProps<Theme> =>
  (theme) => ({
    width: size,
    height: size,
    flex: "none",
    borderRadius: "50%",
    p: theme.spacing(0.375),
    background: customGradients.instagram,
  });

export const inner: SxProps<Theme> = (theme) => ({
  width: "100%",
  height: "100%",
  borderRadius: "50%",
  p: theme.spacing(0.375),
  bgcolor: "background.paper",
});

export const image: SxProps<Theme> = {
  width: "100%",
  height: "100%",
  borderRadius: "50%",
  objectFit: "cover",
  display: "block",
};

export const fallback: SxProps<Theme> = {
  width: "100%",
  height: "100%",
  borderRadius: "50%",
  background: customGradients.instagram,
  color: "common.white",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
